export const Types = {
    GET_PRODUCT_HISTORY_REQUEST: 'GET_PRODUCT_HISTORY_REQUEST',
    RESET_PRODUCT_HISTORY: 'RESET_PRODUCT_HISTORY',
    GET_PRODUCT_HISTORY_SUCCESS: 'GET_PRODUCT_HISTORY_SUCCESS',
    SET_ERROR: 'SET_ERROR',
  }
  
  export const productHistoryRequest = (params) => ({
    type: Types.GET_PRODUCT_HISTORY_REQUEST,
    params,
  });
  
  export const productHistoryReset = () => ({
    type: Types.RESET_PRODUCT_HISTORY,
  });

  
  export const productHistorySuccess = (response) => ({
    type: Types.GET_PRODUCT_HISTORY_SUCCESS,
    payload: response,
  });
  
  export const setError = (error) => ({
    type: Types.SET_ERROR,
    payload: { error }
  });
